import { C, ff } from '../../Dashboard/components/dashboardConstants';
import { IcoSearch, IcoFilter, IcoChevronDown } from './ApplicationsIcons';

const FILTER_OPTIONS = ['전체', '지원완료', '1차통과', '2차통과', '미팅예정', '합격', '불합격'];

export default function ApplicationsSearchBar({ search, setSearch, filter, setFilter, filterOpen, setFilterOpen }) {
  return (
    <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
      {/* 검색 */}
      <div style={{ flex: 1, position: 'relative', display: 'flex', alignItems: 'center' }}>
        <span style={{ position: 'absolute', left: '16px', display: 'flex' }}>
          <IcoSearch />
        </span>
        <input
          value={search}
          onChange={e => setSearch(e.target.value)}
          placeholder="작품명, 제작사, 역할로 검색"
          style={{
            width: '100%', height: '52px', borderRadius: '12px',
            border: `1px solid ${C.g200}`, background: C.white,
            paddingLeft: '48px', paddingRight: '16px',
            boxSizing: 'border-box',
            fontFamily: ff, fontSize: '15px', color: C.bk,
            outline: 'none',
          }}
        />
      </div>

      {/* 필터 드롭다운 */}
      <div style={{ position: 'relative' }}>
        <button
          onClick={() => setFilterOpen(o => !o)}
          style={{
            height: '52px', padding: '0 20px', borderRadius: '12px',
            border: `1px solid ${C.g200}`, background: C.white,
            display: 'flex', alignItems: 'center', gap: '8px',
            cursor: 'pointer', fontFamily: ff, fontSize: '15px',
            color: C.bk, whiteSpace: 'nowrap',
          }}
        >
          <IcoFilter />
          <span>{filter}</span>
          <IcoChevronDown />
        </button>
        {filterOpen && (
          <div style={{
            position: 'absolute', top: '56px', right: 0, zIndex: 200,
            background: C.white, border: `1px solid ${C.g200}`,
            borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.10)',
            overflow: 'hidden', minWidth: '140px',
          }}>
            {FILTER_OPTIONS.map(opt => (
              <button
                key={opt}
                onClick={() => { setFilter(opt); setFilterOpen(false); }}
                style={{
                  display: 'block', width: '100%', padding: '12px 20px',
                  background: opt === filter ? C.g200 : 'transparent',
                  border: 'none', cursor: 'pointer',
                  fontFamily: ff, fontSize: '14px', textAlign: 'left',
                  color: C.bk,
                }}
              >
                {opt}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
